export default {
    path: "/settings",
    name: "settings",
    children: [
        {
            path: "",
            name: "settings",
            component: () => import('@/views/Settings/Index.vue')
        },
        {
            path: "faq",
            name: "faq",
            component: () => import('@/views/Settings/FAQ.vue')
        },
        {
            path: "illumination-text",
            name: "illumination-text",
            component: () => import('@/views/Settings/IlluminationText.vue')
        },
        {
            path: "contact",
            name: "contact",
            component: () => import('@/views/Settings/Contact.vue')
        }
    ]
}
